import React from 'react';
import { Form, Button, Popconfirm } from '@douyinfe/semi-ui';
import { IconDelete, IconPlus } from '@douyinfe/semi-icons';
import { config } from './config';

export const FAQStyleForm = ({ data = {}, onChange }) => {
    const defaultData = {
        ...config.defaultProps
    };

    const handleItemChange = (index, values) => {
        const newItems = [...(data.items || defaultData.items)];
        newItems[index] = { ...newItems[index], ...values };
        onChange?.({ ...data, items: newItems });
    };

    const addItem = () => {
        const newItems = [...(data.items || defaultData.items)];
        const newItem = {
            question: '新的问题？',
            answer: '新的答案'
        };
        newItems.push(newItem);
        onChange?.({ ...data, items: newItems });
    };

    const removeItem = (index) => {
        const newItems = [...(data.items || defaultData.items)];
        newItems.splice(index, 1);
        if (newItems.length === 0) {
            newItems.push({
                question: '这是一个问题？',
                answer: '这是问题的答案'
            });
        }
        onChange?.({ ...data, items: newItems });
    };

    return (
        <div style={{ padding: '16px' }}>
            <div style={{ marginBottom: '12px', fontWeight: 600 }}>问答列表</div>
            {(data.items || defaultData.items).map((item, index) => (
                <div key={`faq-${index}`} style={{ marginBottom: '16px', position: 'relative', borderBottom: index < (data.items || defaultData.items).length - 1 ? '1px solid var(--semi-color-border)' : 'none', paddingBottom: '16px' }}>
                    <Form
                        initValues={{
                            [`question${index}`]: item.question,
                            [`answer${index}`]: item.answer
                        }}
                        onValueChange={(values) => handleItemChange(index, {
                            question: values[`question${index}`],
                            answer: values[`answer${index}`]
                        })}
                    >
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px' }}>
                            <Form.Input
                                field={`question${index}`}
                                label={`问题 ${index + 1}`}
                                style={{ width: '100%' }}
                            />
                            <Form.TextArea
                                field={`answer${index}`}
                                label="答案"
                                style={{ width: '100%' }}
                                rows={4}
                            />
                        </div>
                    </Form>
                    {(data.items || defaultData.items).length > 1 && (
                        <Popconfirm
                            title="确定要删除该问答吗？"
                            onConfirm={() => removeItem(index)}
                        >
                            <Button
                                type="danger"
                                theme="borderless"
                                icon={<IconDelete />}
                                style={{ position: 'absolute', right: 0, top: '-5px' }}
                            />
                        </Popconfirm>
                    )}
                </div>
            ))}
            <Button icon={<IconPlus />} onClick={addItem} theme="light" style={{ width: '100%' }}>
                添加问答
            </Button>
        </div>
    );
};

export default FAQStyleForm;